<template>
  <!--Mobile-->
  <div v-if="guest">
    <div v-if="smAndDown">
      <!-- Guest name -->
      <v-layout class="user-name margin-y-auto" align-center>
        <img v-if="isChild" class="mr-2" height="30" src="@/assets/lollipop.png">
        <div>
          <div v-if="isDisabled">{{
            $t("guest.bye")
          }}</div>
          <div
            >{{ !isDisabled ? `${$t("guest.welcome")},` : "" }} {{ name }}
          </div>
          <div v-if="tagId" class="secondary--text caption">{{
            tagId
          }}</div>
        </div>
      </v-layout>
      <!--Refund/topup and balance-->
      <v-layout align-end wrap>
        <v-layout v-if="isGuestDisabled(guest.guest) && !refundRequest"
          align-center
          @click="goToRefund()"
          :loading="loadingLastRefundRequest"
          class="clickable mt-4">
          <template v-if="balance && balance > 0">
            <img :src="require('@/assets/refund.png')" width="30px" class="mr-2">
            <span style="color: var(--v-primary-base);">{{ $t('guest.get_refund') }}</span>
          </template>
        </v-layout>
        <v-layout v-else-if="refundRequest">
          <refund-request-button
            :item="refundRequest"
            @click="$emit('showRequest')"
            class="pr-2 mt-4"
          />
        </v-layout>
        <!-- <v-layout v-else pa-1>
          <span class="primary--text mt-4 clickable">
            <v-icon color="primary" class="mr-2">add</v-icon
            >{{ $t("guest.top_up") }}
          </span>
        </v-layout> -->
        <guest-balance class="mt-4" />
      </v-layout>
    </div>
    <!--Desktop-->
    <v-layout v-else class="wrapper" ml-8 mr-8>
      <v-flex sm7 class="desktop-card-left pa-8 align-center d-flex">
        <v-layout wrap align-center>
          <img v-if="isChild" class="mr-2" height="30" src="@/assets/white-lollipop.png">
          <div>
            <div class="white--text display-1 font-weight-bold">{{ isDisabled ? $t("guest.bye") : `${$t("guest.welcome")},` }} {{ name }}</div>
            <span v-if="tagId" class="desktop-tag">{{ tagId }}</span>
          </div>
        </v-layout>
      </v-flex>
      <!--Refund/topup and balance-->
      <v-flex sm5 class="desktop-card-rigth pa-8 d-flex" :style="`background-color: ${refundRequestColor};`">
        <v-layout justify-space-between align-center wrap>
          <guest-balance desktop />
          <v-layout v-if="isGuestDisabled(guest.guest) && !refundRequest"
            @click="goToRefund()"
            :loading="loadingLastRefundRequest"
            class="clickable mt-2"
            align-center
            justify-end>
            <template v-if="balance && balance > 0">
              <img :src="require('@/assets/refund_white.png')" width="30px" class="mr-2">
              <span class="white--text">{{ $t('guest.get_refund') }}</span>
            </template>
          </v-layout>
          <refund-request-button v-else-if="refundRequest"
            :item="refundRequest"
            @click="$emit('showRequest')"
            :class="{ 'my-2': xsOnly, 'mt-4': mdOnly, 'margin-y-auto': lgAndUp }"
            dark
          />
          <!-- <span v-else class="white--text my-2 clickable">
            <v-icon color="white" class="mr-2">add</v-icon
            >{{ $t("guest.top_up") }}
          </span> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import routeNames from '@/router/routes'
import moneyFormatMixins from '@/mixins/MoneyFormat'
import vuetifyMixins from '@/mixins/Vuetify'
import { refundRequestStatus } from '@/config'

export default {
  props: {
    isChild: Boolean,
    isDisabled: Boolean,
    name: String,
    tagId: String,
    loadingLastRefundRequest: Boolean
  },
  methods: {
    goToRefund () {
      if (this.refundGuestId && this.refundGuestId !== this.$route.params.id) {
        this.$store.commit('refund/resetEdited')
      } else if (!this.refundGuestId) {
        this.$store.commit('refund/setField', { field: 'guestId', value: this.$route.params.id })
      }
      this.$router.push({ name: routeNames.refund.name })
    }
  },
  computed: {
    ...mapState({
      guest: (state) => state.guests.read,
      refundGuestId: state => state.refund.guestId,
      refundRequest: state => state.guests.refundRequest
    }),
    ...mapGetters({
      getBalance: 'guests/getBalance',
      isGuestDisabled: 'guests/getIsGuestDisabled'
    }),
    balanceData () {
      return this.getBalance()
    },
    balance () {
      return this.balanceData ? this.balanceData.balance : null
    },
    refundRequestColor () {
      if (!this.refundRequest) return 'var(--v-primary-base)'
      switch (this.refundRequest.status) {
        case refundRequestStatus.ACCEPTED:
          return 'var(--v-success-lighten1)'
        case refundRequestStatus.REJECTED:
          return 'red'
        default:
          return 'var(--v-primary-base)'
      }
    }
  },
  components: {
    RefundRequestButton: () => import('@/components/view-components/buttons/RefundRequestButton.vue'),
    GuestBalance: () => import('@/components/view-components/GuestBalance.vue')
  },
  mixins: [vuetifyMixins, moneyFormatMixins]
}
</script>

<style lang="scss" scoped>
.user-name {
  font-size: 20px;
  color: var(--v-primary-base);
  font-weight: 600;
}
.balance {
  font-size: 26px;
  color: var(--v-primary-base);
  font-weight: 400;
}
.desktop-card-left {
  border-radius: 15px 0px 0px 15px;
  background-color: #00a8df;
}
.desktop-card-rigth {
  border-radius: 0px 15px 15px 0px;
}
.desktop-tag {
  color: white;
  font-size: 14px;
}
</style>
